import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Table,
  Spin,
  Select,
  Statistic,
} from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { apiConfig, labelConfig, staticConfig } from "../operations.config";
import dayjs from "dayjs";

import Notiflix from "notiflix";
import { accountStatus } from "../../../components/facilities/AccountFacility";
const dateFormat = "DD-MM-YYYY";

const columns = [
  {
    title: labelConfig.customer,
    dataIndex: "customer",
  },
  {
    title: labelConfig.loan,
    dataIndex: "loan",
    sorter: (a, b) => a.resourceId.localeCompare(b.resourceId),
  },
  {
    title: labelConfig.amount,
    dataIndex: "amount",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },

  {
    title: labelConfig.loanPurpose,
    dataIndex: "loanPurpose",
  },

  {
    title: labelConfig.branch,
    dataIndex: "branch",
  },
];

const ManageLoanApproval = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  //   const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [officeData, setOfficeData] = useState([]);
  const [loanList, setLoanList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [currentDate, setCurrentDate] = useState("");

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setLoanList(originalList);
      return;
    }

    const filterBySearch = originalList.filter(
      (item) =>
        item?.customer?.toLowerCase().includes(searchKey) ||
        item?.branch?.toLowerCase().includes(searchKey)
    );

    setLoanList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  //END METHODS DECLARED

  useEffect(() => {
    getOffice();
    defaultDate();
    // getLoans();
    // BOM.HasPermission("READ_AUDIT") &&
    // rightAction(cnt.RIGHT_SEARCH_BTN);
  }, []);

  const defaultDate = () => {
    setCurrentDate(dayjs());
  };

  const getOffice = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.Offices, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempOffice = [];

        objList.forEach((element) => {
          tempOffice.push({
            value: element.id,
            label: element.name,
          });
        });

        // setOfficeData(tempOffice);
        getLoans(tempOffice);
      }
    });
  };

  const getLoans = (tempOffice) => {
    const params = {
      limit: 1000,
      sqlSearch: "l.loan_status_id in (100,200)",
    };

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, apiConfig.Loans, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res.pageItems.filter(
          (item) =>
            item?.status?.value?.toLowerCase() ===
            accountStatus.submittedAndPending
        );

        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            customer: element?.clientName ? element?.clientName : "-",
            loan: element?.loanProductName
              ? `${element?.loanProductName} (${element.accountNo})`
              : "-",
            amount: element?.principal ? element?.principal : "-",
            loanPurpose: element?.loanPurposeName
              ? element?.loanPurposeName
              : "-",
            branch: element.clientOfficeId
              ? tempOffice.find((item) => item.value === element.clientOfficeId)
                  .label
              : "-",
          });
        });

        setLoanList(tempArray);

        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  // FLOAT METHODS
  //   function handleOnView() {
  //     // console.log(selectedRow);return
  //     delete selectedRow.amount;
  //     selectedRow.amount = selectedRow.amountToUse;
  //     const { detailBtn } = rightBtn;
  //     if (detailBtn.toLowerCase() === "primary") {
  //       navigate("/detail-audit-trail", { state: selectedRow });
  //     } else {
  //       console.log("Please choose a record from the table to open");
  //     }
  //   }

  //   function handleOnSearch() {
  //     const { searchBtn } = rightBtn;
  //     if (searchBtn.toLowerCase() === "primary") {
  //       navigate("/search-audit-trail", { ofObj: selectedRow });
  //     } else {
  //       console.log("Could not open the link");
  //     }
  //   }

  const onSelectItemAction = (selectedKeys, selectedRows) => {
    //HOLD THE OBJECT SELECTED HERE

    console.log(`selectedKeys`, selectedKeys);
    console.log(`selected-row`, selectedRows);

    setSelectedRowKeys(selectedKeys);
    setSelectedRow(selectedRows);

    [BOM.HasPermission("APPROVE_LOAN") && cnt.RIGHT_APPROVE_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  const handleApprove = () => {
    let action = "Confirm Approval";
    console.log(BOM.DateTime(currentDate, "only-date"));

    Notiflix.Confirm.show(
      "Are you sure?",
      action,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        let tempBatchArray = selectedRow.map((element, index) => ({
          requestId: index + 1,
          relativeUrl: `loans/${element.id}?command=approve`,
          method: "POST",
          body: JSON.stringify({
            approvedOnDate: BOM.DateTime(currentDate, "only-date"),
            dateFormat: "dd MMMM yyyy",
            locale: "en",
          }),
        }));

        tempBatchArray.session = session;
        tempBatchArray.method = "POST";

        const url = apiConfig.Batches;

        BOM.FetchReqAction(tempBatchArray, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, "Approved successfully");
            // navigate("/sms0802");
            dispatch({
              type: cnt.CLEAR_RIGHT_BTN,
            });

            // rightAction(cnt.RIGHT_SEARCH_BTN);

            getOffice();
            //STOP LOAD
            // Clear selection after successful approval
            setSelectedRowKeys([]);
            setSelectedRow([]);
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true} onApprove={handleApprove}>
      <TopContent
        pageTitle={labelConfig.manageLoanApproval}
        pageItems={staticConfig.manageLoanApprovalBreadcrumbItems}
      />

      <Card
        title={`${labelConfig.loan} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Customer/Branch..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={loanList}
              columns={columns}
              fileName={"Audit Trail List"}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "checkbox",
              onChange: onSelectItemAction,
              selectedRowKeys: selectedRowKeys, // Controlled selection
            }}
            columns={columns}
            dataSource={loanList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageLoanApproval);
